// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"484":"dd9c206d","595":"6766b4c1","732":"5160a7ee","930":"42e3d65b"}[chunkId] + ".chunk.css";
};